// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"4eb4cee1","912":"b2b9debe","933":"d52eb3d4"}[chunkId] + ".chunk.css";
};